import api from '../config/axios';

export const calculateEligibility = (data) => api.post('/calculator/eligibility', data);
